var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-search-bar",
            {
              attrs: {
                "show-currency": false,
                "is-manage-module": true,
                "show-schedule": false,
                filter: _vm.filter
              },
              on: {
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemResetCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _vm.activeTabName === "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditCP",
                            type: "primary",
                            disabled: !this.cpSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.deleteAllowed_CP,
                              expression: "deleteAllowed_CP"
                            }
                          ],
                          attrs: { no: "onDeleteCP", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_CP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeTabName !== "cpList"
                ? _c(
                    "template",
                    { slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: {
                            no: "onEditPP",
                            type: "primary",
                            disabled: !this.ppSelectRow
                          },
                          on: {
                            click: function($event) {
                              return _vm.onEdit_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "onDeletePP", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.onDelete_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.approveAllowed_PP,
                              expression: "approveAllowed_PP"
                            }
                          ],
                          attrs: { no: "onApprovePP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onApprove_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Approve")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onAddPP", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onAdd_PP()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          attrs: { no: "onDownloadTemplate", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.onDownloadTemplate()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                      ),
                      _c(
                        "el-upload",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.inputAllowed_PP,
                              expression: "inputAllowed_PP"
                            }
                          ],
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "5px"
                          },
                          attrs: {
                            no: "onEditCP",
                            action:
                              _vm.URL.price.priceWeightLimit.saveExcelFile,
                            headers: { sessionId: _vm.sessionId },
                            "show-file-list": false,
                            accept: ".xls, .xlsx",
                            "on-success": _vm.uploadExcelSuccess,
                            data: {
                              currentOfficeId:
                                _vm.$store.getters.currentOfficeId
                            }
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { no: "import", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("weight-limit-data-grid", {
                    attrs: {
                      "config-module": "221001",
                      "row-data": _vm.rowCpData,
                      "show-approve": true,
                      "show-create": true,
                      "show-modify": true,
                      filter: _vm.filter,
                      "grid-options": _vm.cpGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("weight-limit-data-grid", {
                    attrs: {
                      "config-module": "221002",
                      "row-data": _vm.rowPpData,
                      "show-create": true,
                      "show-modify": true,
                      "show-selection": true,
                      filter: _vm.filter,
                      "grid-options": _vm.ppGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.weightLimitFormDialog.visible
        ? _c("weight-limit-form", {
            attrs: {
              visible: _vm.weightLimitFormDialog.visible,
              price: _vm.weightLimitFormDialog.price,
              "is-new": _vm.weightLimitFormDialog.isNew
            },
            on: { close: _vm.onWeightLimitFormDialogClose, reload: _vm.toQuery }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }